<template>
    <div class="registration">
        <div class="registration__container">
            <div class="registration__header">
                <h2>{{$t('lang.login.authorization')}}</h2>
            </div>
            <div class="registration__content">
                <div class="field">
                    <IconField iconPosition="right">
                        <InputIcon class="pi pi-at" />
                        <InputText
                            :class="[v$.currentEmail.$error ?  'p-invalid' : '']"
                            v-model="currentEmail"
                            @keydown.enter="loginUser"
                            type="email"
                            name="email"
                            :placeholder="$t('lang.login.login')"
                            required
                        />
                    </IconField>
                    <span
                        v-if="v$.currentEmail.$error && v$.currentEmail.$errors[0].$message.length > 0"
                        class="registration__text-error"
                    >
                        {{ v$.currentEmail.$errors[0].$message }}
                    </span>
                </div>
                <div class="field">
                    <span class="registration__password-wrapper">
                        <AdaptersPassword
                            :class="[v$.currentPass.$error ?  'p-invalid' : '']"
                            v-model="currentPass"
                            @keydown.enter="loginUser"
                            inputId="register__reg_pass"
                            :inputProps="{name: 'password'}"
                            :placeholder="$t('lang.login.password')"
                            required
                            toggleMask
                            :feedback="false"
                        />
                        <a class="registration__green-text" href="/forgotpassword" target="_blank">
                            {{ $t('lang.login.restore_password') }}
                        </a>
                    </span>
                </div>
                <AdaptersMessage v-if="error" :message="error" />
            </div>
            <Button
                id="recaptcha"
                class="registration__btn"
                :class="[disableBtn ? 'registration__btn-disabled' : '']"
                :disabled="disableBtn"
                :label="$t('lang.login.enter')"
                @click="loginUser"
            />
            <div class="registration__footer">
                <label class="registration__or-login">{{ $t('lang.registration.or_login') }}</label>
                <div class="auth_btn_container">
                    <div @click="yandexIdLogin" class="registration__other_system">
                        <div class="ya" />
                        <label>{{ $t('lang.login.btn_login_yandex') }}</label>
                    </div>
                    <div @click="elamaLogin" class="registration__other_system">
                        <div class="elama" />
                        <label>{{ $t('lang.login.btn_login_elama') }}</label>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <label class="registration__already-exist" >
        {{ $t('lang.login.registration_redirect') }}
        <a
            class="green_link"
            :href="'/registration' + (redirectUrl ? '?redirect=' + redirectUrl : '')"  target='_blank'
        >
            {{ $t('lang.login.register_title') }}
        </a>
    </label>
</template>

<script>
import AdaptersPassword from "../../component/adapters/Password.vue";
import InputMask from "primevue/inputmask";
import InputText from "primevue/inputtext";
import Checkbox from "primevue/checkbox";
import Button from "primevue/button";
import IconField from "primevue/iconfield";
import InputIcon from "primevue/inputicon";
import AdaptersMessage from "../../component/adapters/Message.vue";
import Alerts from "../../mixins/Alerts";
import UserApi from "../../api/UserApi";
import { useVuelidate } from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import Redirect from "../../mixins/Redirect";

export default {
    name: "LoginForm",
    mixins: [Alerts, Redirect],
    data() {
        return {
            currentEmail: '',
            currentPass: '',
            error: '',
            disableBtn: true,
            redirectUrl: '',
            v$: null,
            t: null
        };
    },
    created() {
        const rules = {
            currentEmail: {
                required: helpers.withMessage('', required),
                email: helpers.withMessage(this.$t('lang.registration.incorrect_email'), email),
            },
            currentPass: {
                required: helpers.withMessage('', required),
            }
        };

        this.v$ = useVuelidate(rules, this);

        const urlParams = new URLSearchParams(window.location.search);
        this.redirectUrl = urlParams.get('redirect');
    },
    methods: {
        fieldsNotEmpty() {
            if (!this.currentEmail || !this.currentPass) {
                this.disableBtn = true;
            }
        },
        loginUser() {
            this.error = '';
            this.v$.$validate();
            this.disableBtn = this.v$.$errors.length > 0;

            if (!this.disableBtn) {
                this.disableBtn = true;
                UserApi
                    .login({
                        email: this.currentEmail,
                        password: this.currentPass,
                    })
                    .then(() => this.safeRedirect(this.redirectUrl))
                    .catch((error) => {
                        this.disableBtn = false;
                        this.error = error.message;
                    });
            }
        },
        yandexIdLogin() {
            window.location.href =
                'https://oauth.yandex.ru/authorize?client_id=' +
                process.env.YANDEX_ID_CLIENT_ID +
                '&redirect_uri=' +
                window.location.origin +
                '/ru/suggest/token?redirect=' +
                (this.redirectUrl ?? '/') +
                '&response_type=token&force_confirm=1';
        },
        elamaLogin() {
            window.location.href =
                'https://new.elama.ru/api/oauth-provider/init?response_type=code&scope=login&client_id=' +
                process.env.ELAMA_CLIENT_ID +
                '&redirect_uri=' +
                window.location.origin +
                '/ru/auth-elama';
        },
    },
    watch: {
        currentEmail() {
            this.v$.currentEmail.$validate();
            this.disableBtn = this.v$.$errors.length > 0;
            this.fieldsNotEmpty();
        },
        currentPass() {
            this.v$.currentPass.$validate();
            this.disableBtn = this.v$.$errors.length > 0;
            this.fieldsNotEmpty();
        }
    },
    components: {
        AdaptersPassword,
        AdaptersMessage,
        InputMask,
        InputText,
        Checkbox,
        Button,
        IconField,
        InputIcon,
    },
};
</script>
